import { useMemo } from "react";

import { useAdoptedBudgetMix } from "@features/mmm/hooks/use-adopted-budget-mix";

import { usePerformanceTrackingData } from "./performance-tracking-provider";

export const usePerformanceTrackingSpendData = () => {
  const { data, loading } = usePerformanceTrackingData();

  const { adoptedBudgetMix } = useAdoptedBudgetMix();

  const trackingSpendData = useMemo(() => {
    const performanceTrackingData =
      data?.me?.mmm?.performanceTracking?.performanceTrackingSpendData ?? [];

    return performanceTrackingData;
  }, [data]);

  const isLoading =
    loading || trackingSpendData.length === 0 || !adoptedBudgetMix;

  return {
    loading: isLoading,
    trackingSpendData,
  };
};
